import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpInterceptor } from '../../../../interceptors/http-interceptor.service';
import { Globals } from '../../../../globals';
import { PermisoService } from '../../../../providers/permiso.service';
import { Observable } from 'rxjs/Observable';
import { TipoCliente } from './tipo-cliente';
import { GeneralService } from '../../../../providers/general.service';

@Injectable()
export class TipoClienteService {
    constructor(
        private http: HttpInterceptor,
        private globals: Globals,
        private general: GeneralService,
        private permisoService: PermisoService
    ) { }

    crearTipoCliente(tipoCliente: TipoCliente): Observable<any> {
        return this.permisoService.getPermisoAction('TIPO-CLIENTE-CREAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            tipoCliente: tipoCliente
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    editarTipoCliente(tipoCliente: TipoCliente): Observable<any> {
        return this.permisoService.getPermisoAction('TIPO-CLIENTE-EDITAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            tipoCliente: tipoCliente
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    eliminarTipoCliente(IdTipoCliente: number): Observable<any> {
        return this.permisoService.getPermisoAction('TIPO-CLIENTE-ELIMINAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            IdTipoCliente: IdTipoCliente
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }

    getTiposCliente(
        paginado: any = {
            page: null,
            pageSize: null
        },
        orden: any = {
            sort: 'descripcion',
            order: 'asc'
        },
        filtros: any = {
            generico: ''
        }
    ): Observable<any> {
        return this.permisoService
            .getPermisoAction('TIPOS-CLIENTE-VER')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this.http
                    .post(
                        this.general.webserver + controllerAction,
                        JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
                            paginado: paginado,
                            orden: orden,
                            filtros: filtros
                        })
                    );
            })
            .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
                (respuesta: Response) => respuesta.json());
    }
}